import { defineNuxtPlugin } from '#app/nuxt'
import { LazyEligibilityPassedModal, LazyFtuModal, LazyGlobalCampaignDetailSidebar, LazyGlobalFAQ, LazyGlobalVerifyFollowingOfXAccount, LazyNewPostModal, LazyPaydayModal, LazyVerifyEmailOtpModal, LazyVerifyTfaOtpModal, LazyWarningBanner, LazyWithdrawalOtpModal, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["EligibilityPassedModal", LazyEligibilityPassedModal],
["FtuModal", LazyFtuModal],
["GlobalCampaignDetailSidebar", LazyGlobalCampaignDetailSidebar],
["GlobalFAQ", LazyGlobalFAQ],
["GlobalVerifyFollowingOfXAccount", LazyGlobalVerifyFollowingOfXAccount],
["NewPostModal", LazyNewPostModal],
["PaydayModal", LazyPaydayModal],
["VerifyEmailOtpModal", LazyVerifyEmailOtpModal],
["VerifyTfaOtpModal", LazyVerifyTfaOtpModal],
["WarningBanner", LazyWarningBanner],
["WithdrawalOtpModal", LazyWithdrawalOtpModal],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
